import { makeStyles } from 'tss-react/mui';

const name = 'SelectedGroupAvatar';

export const useSelectedGroupAvatarStyles = makeStyles({ name })(theme => ({
  avatar: {
    flexShrink: 0,
    width: 32,
    height: 32,

    [theme.breakpoints.down('xs')]: {
      width: 24,
      height: 24,
    },
  },
  personalIcon: {
    fontSize: 28,
  },
}));
